import React, { useEffect, useState } from "react";
import {
  avatar,
  cmmt1,
  cmmt2,
  cmmt3,
  cmmt4,
  cmmt5,
  img_placehlder,
  memeber1,
  new_rqt_one,
} from "../../../../assets";
import SideDrawer from "../../../../Components/sideDrower/SideDrawer";
import { feedCommentApi } from "../../../../services/feeds";
import { toastMessage } from "../../../../utils/toastMessage";
import { CiSearch } from "react-icons/ci";
import { Link, useSearchParams } from "react-router-dom";
import "../groupRequestDrawer/GroupMemberList.css";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import ReportSideDrawer from "../../../../Components/sideDrower/ReportSideDrawer";
import {
  groupMemberListApi,
  updateGroupMemberApi,
} from "../../../../services/groupMember";
import useDebounce from "../../../../hooks/useDebounce";
import { LoadingButton } from "../../../../Components/header/form";
import OverviewReport from "../../Overview/section/OverviewReport";
import ExitGroup from "../memberGroup/ExitGroup";
import { FaStar } from "react-icons/fa";

const GroupMemberList = ({
  joinGroupRequestModal,
  setJoinGroupRequestModal,
  groupId,
  listing = () => {},
  newRequest,
  groupDetail,
}) => {
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [loading, setLoading] = useState(false);
  // const [content, setContent] = useState({ _feed: groupId, content: "", });
  const [showReportModal, setShowReportModal] = useState(false);
  const [memberId, setMemberId] = useState(null);
  const [memberList, setMemberList] = useState([]);
  const [memberType, setMemberType] = useState("member");
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [loaders, setLoaders] = useState({ accepted: false, rejected: false });
  const [exitGroupModal, setExitGroupModal] = useState(false);
  const [selectedData, setSelectedData] = useState(false);
  const [isLoginUserAdmin, setIsLoginUserAdmin] = useState(false);
  //-------handle-exit-group----------
  const handleExitGroup = (data) => {
    setSelectedData(data);
    setExitGroupModal(true);
  };
  const statusHandler = async (item, status) => {
    try {
      let payload = {
        _group: item?._group,
        _user: item?._user?._id,
        status: status,
      };
      if (status === "ACCEPTED") {
        setLoaders({ accepted: true, rejected: false });
      } else {
        setLoaders({ accepted: false, rejected: true });
      }
      const { data } = await updateGroupMemberApi(payload);
      const { success, message, data: response } = data;
      if (success) {
        fetchGroupMemberList();
        if (status === "ACCEPTED") {
          setTimeout(() => {
            listing();
          }, 1000);
        }
      }
      toastMessage(message, success ? "success" : "error", "joinHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoaders({ accepted: false, rejected: false });
    }
  };

  function isAdmin(sendingId, usersArray) {
    const admin = usersArray.find((user) => user.role === "ADMIN");
    return admin ? admin._user._id === sendingId : false;
  }

  //----------------------------------------------
  //Member List
  const fetchGroupMemberList = async () => {
    try {
      setLoading(true);
      const { data } = await groupMemberListApi({
        search: debouncedValue,
        _id: groupId,
        status: memberType === "memberRequest" ? "request" : "",
      });
      const { success, message, data: response } = data;

      if (success) {
        setMemberList(response);
        setIsLoginUserAdmin(isAdmin(showAuth._id, response));
      } else {
        toastMessage(message, "error", "getGroupDetail");
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchGroupMemberList();
  }, [memberType, debouncedValue]);

  // console.log(isLoginUserAdmin, "isLoginUserAdmin")

  return (
    <>
      <SideDrawer
        className="all_member_head"
        show={joinGroupRequestModal}
        handleClose={() => setJoinGroupRequestModal(false)}
      >
        <h3 className="drawer_title"> Member</h3>

        <div className="tabber">
          <ul className="tab_button">
            <li
              className={memberType === "member" ? "active" : ""}
              onClick={() => setMemberType("member")}
            >
              All Members
            </li>
            {!newRequest && (
              <li
                className={memberType === "memberRequest" ? "active" : ""}
                onClick={() => setMemberType("memberRequest")}
              >
                New Request
              </li>
            )}
          </ul>

          <div className="search_group">
            <CiSearch />
            <input
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              className="search_bar"
              placeholder="Search"
            />
          </div>

          {memberType === "member" &&
            (loading ? (
              <h5 className="text-center mt-4">Loading...</h5>
            ) : (
              <div className="member_list">
                <ul className="user_list">
                  {memberList?.map((data) => (
                    <li key={data?._user?._id} className="user_item">
                      {groupDetail?.settings?.showAdminBadge &&
                        data?._user?._id === showAuth?._id && (
                          // <div className="tag ">ADMIN</div>
                          <div className="star_icons">
                            <FaStar />
                          </div>
                        )}
                      <img
                        src={data?._user?.profilePicture || avatar}
                        alt="Avatarrr"
                      />

                      <div className="user_info">
                        <div className="user_name">{data?._user?.fullName}</div>
                      </div>
                      <div className="options">
                        {data?._user?._id !== showAuth?._id && (
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                            >
                              <BsThreeDotsVertical />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item
                                as={Link}
                                to={`/dashboard/group/groupRequestDrawer/Send_Msg_Req/${data?._user?._id}`}
                              >
                                View Profile
                              </Dropdown.Item>
                              {isLoginUserAdmin && (
                                <Dropdown.Item
                                  as={Link}
                                  to="#"
                                  onClick={() => handleExitGroup(data)}
                                >
                                  Remove Member
                                </Dropdown.Item>
                              )}

                              <Dropdown.Item
                                as={Link}
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setMemberId(data?._user?._id);
                                  setShowReportModal(true);
                                }}
                              >
                                Report
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          {!newRequest &&
            memberType === "memberRequest" &&
            (loading ? (
              <h5 className="text-center mt-4">Loading...</h5>
            ) : (
              <div className="new_request_parent">
                {memberList && memberList.length > 0 ? (
                  memberList?.map((data, ind) => (
                    <ul key={ind} className="new_requset_wraper">
                      <li className="rqt_join_grpes">
                        <img
                          src={data?._user?.profilePicture || avatar}
                          alt="Request_first"
                        />

                        <div className="rqt_join_content">
                          <p className="text">
                            <b className="name">{data?._user?.fullName}</b> has
                            requested to join your group.
                          </p>

                          <div className="acceot_btn_wraper">
                            <LoadingButton
                              loading={loaders?.rejected}
                              onClick={() => statusHandler(data, "REJECTED")}
                              className="reject_btn"
                              type="button"
                            >
                              Reject
                            </LoadingButton>
                            <LoadingButton
                              loading={loaders?.accepted}
                              onClick={() => statusHandler(data, "ACCEPTED")}
                              className="accept_btn"
                              type="button"
                            >
                              Accept
                            </LoadingButton>
                          </div>
                        </div>
                      </li>
                    </ul>
                  ))
                ) : (
                  <h5 className="text-center mt-4">No Request Found</h5>
                )}
              </div>
            ))}
        </div>
      </SideDrawer>

      {showReportModal && (
        // <ReportSideDrawer
        //   type={"USER"}
        //   reportId={memberId}
        //   showDrawer={showReportModal}
        //   setShowDrawer={setShowReportModal}
        // />

        <OverviewReport
          type={"USER"}
          show={showReportModal}
          close={() => setShowReportModal(false)}
          // selectedData={selectedData}
          pageName="Member"
          id={memberId}
        />
      )}

      {/* ---------group-exit--------------- */}
      <ExitGroup
        show={exitGroupModal}
        close={() => setExitGroupModal(false)}
        memberId={selectedData?._user?._id}
        memberApi={fetchGroupMemberList}
        groupId={selectedData?._group}
        type="MEMBER"
        groupName={groupDetail?.name}
        detailAPi={listing}
      />
    </>
  );
};

export default GroupMemberList;
